module.exports = __webpack_public_path__ + "img/3.e76e3cb3.jpg";